import {deserialize, deserializeAs, inheritSerialization} from 'cerialize';
import {Entity} from './entity';

@inheritSerialization(Entity)
export class Contact extends Entity {

    @deserialize
    nom: string = null;

    @deserialize
    metier: string = null;

    @deserialize
    email: string = null;

    @deserializeAs("numero_telephone")
    numeroTelephone: string = null;

    @deserializeAs("ajoute_par_particulier")
    ajouteParParticulier: boolean = null;

    @deserialize
    roles: string[] = [];

    photo: string;

    @deserialize
    site: string = null;

    public static OnDeserialized(instance: Contact, json: any): void {
        if (json.photo && json.photo.url) {
            instance.photo = json.photo.url;
        }
    }

}
